import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import ForgetPassword from "../pages/auth/forget-password";
import ResetPassword from "../pages/auth/reset-password";
import VerifyEmail from "../pages/auth/verify-email";
import AdminLayout from "../layouts/adminLayout";
import Sample from "../pages/Sample";
import Print from "../pages/Print";

import {lazy} from "react";
import {AddFollowUpUser} from "../services";

const Dashboard = lazy(() => import("../pages/Dashboard"));

const UsersList = lazy(() => import("../pages/User/List"));
const UserNew = lazy(() => import("../pages/User/New"));
const UploadUserExcelFIle = lazy(() => import("../pages/User/UploadExcel"));
const UserEdit = lazy(() => import("../pages/User/Edit"));
const UserRole = lazy(() => import("../pages/User/UserRole"));
const RoleList = lazy(() => import("../pages/Role/List"));
const RoleNew = lazy(() => import("../pages/Role/New"));
const RoleEdit = lazy(() => import("../pages/Role/Edit"));
const UpdateRolePermission = lazy(() => import("../pages/Role/UpdateRolePermission"));

const PermissionList = lazy(() => import("../pages/Permission/List"))
const PermissionNew = lazy(() => import("../pages/Permission/New"));
const PermissionEdit = lazy(() => import("../pages/Permission/Edit"))

const PermissionCategoryList = lazy(() => import("../pages/PermissionCategory/List"));
const PermissionCategoryNew = lazy(() => import("../pages/PermissionCategory/New"));
const PermissionCategoryEdit = lazy(() => import("../pages/PermissionCategory/Edit"));




const ChangeForcePassword = lazy(()=> import("../pages/auth/changeForcePassword"));

const Test = lazy(()=> import("../pages/Test/Test"));

const CityList = lazy(() => import("../pages/City/List"));
const CityNew = lazy(() => import("../pages/City/New"));
const CityEdit = lazy(() => import("../pages/City/Edit"));

const StateList = lazy(() => import("../pages/State/List"));
const StateNew = lazy(() => import("../pages/State/New"));
const StateEdit = lazy(() => import("../pages/State/Edit"));

const ContentCategoryList = lazy(() => import("../pages/ContentCategory/List"));
const ContentCategoryNew = lazy(() => import("../pages/ContentCategory/New"));
const ContentCategoryEdit = lazy(() => import("../pages/ContentCategory/Edit"));

const ContentList = lazy(() => import("../pages/Content/List"));
const ContentNew = lazy(() => import("../pages/Content/New"));
const ContentEdit = lazy(() => import("../pages/Content/Edit"));

const ProductCategoryList = lazy(() => import("../pages/ProductCategory/List"));
const ProductCategoryNew = lazy(() => import("../pages/ProductCategory/New"));
const ProductCategoryEdit = lazy(() => import("../pages/ProductCategory/Edit"));

const FrequentQuestionCategoryList = lazy(() => import("../pages/FrequentQuestionCategory/List"));
const FrequentQuestionCategoryNew = lazy(() => import("../pages/FrequentQuestionCategory/New"));
const FrequentQuestionCategoryEdit = lazy(() => import("../pages/FrequentQuestionCategory/Edit"));

const FrequentQuestionList = lazy(() => import("../pages/FrequentQuestion/List"));
const FrequentQuestionNew = lazy(() => import("../pages/FrequentQuestion/New"));
const FrequentQuestionEdit = lazy(() => import("../pages/FrequentQuestion/Edit"));

const BranchList = lazy(() => import("../pages/Branch/List"));
const BranchNew = lazy(() => import("../pages/Branch/New"));
const BranchEdit = lazy(() => import("../pages/Branch/Edit"));

const ProductList = lazy(() => import("../pages/Product/List"));
const ProductNew = lazy(() => import("../pages/Product/New"));
const ProductEdit = lazy(() => import("../pages/Product/Edit"));

const SliderList = lazy(() => import("../pages/Slider/List"))
const SliderNew = lazy(() => import("../pages/Slider/New"));
const SliderEdit = lazy(() => import("../pages/Slider/Edit"));

const UserBasketList = lazy(() => import("../pages/UserBasket/List"));
const KashmarUserBasketList = lazy(() => import("../pages/UserBasket/KashmarList"));

const ConfirmUserBasketList = lazy(() => import("../pages/UserBasket/ConfirmList"));

const UserBasketEdit = lazy(() => import("../pages/UserBasket/Edit"));


const ContactusList = lazy(() => import("../pages/ContactUs/List"));
const ContactUsEdit = lazy(() => import("../pages/ContactUs/Edit"));

const RequestBranchList = lazy(() => import("../pages/RequestBranch/List"));


const BranchProductList = lazy(() => import("../pages/BranchProduct/List"))
const BranchProductNew = lazy(() => import("../pages/BranchProduct/New"));
const BranchProductEdit = lazy(() => import("../pages/BranchProduct/Edit"));
const EmploymentList = lazy(() => import("../pages/Employment/List"));
const BranchShop = lazy(() => import("../pages/BranchShop/List"));


const BranchBasketList = lazy(() => import("../pages/BranchBasket/List"))
const BranchBasketEdit = lazy(() => import("../pages/BranchBasket/Edit"));

//const MarketerBasketItem = lazy(() => import("../pages/Marketer/Basket/MarketerBasketItem"));
//const Invoice = lazy(() => import("../pages/Marketer/UserCategory/Invoice"));

export const mainRoute = [
    {
        id: 0,
        path: '/*',
        component: AdminLayout,
        isProtected: true
    },
    {
        id: 1,
        title: "ورود",
        path: '/login',
        component: Login,
        isProtected: false
    },
    {
        id: 2,
        title: "ثبت نام",
        path: '/register',
        component: Register,
        isProtected: false
    },
    {
        id: 3,
        title: "فراموشی رمز عبور",
        path: '/forget-password',
        component: ForgetPassword,
        isProtected: false
    },
    {
        id: 4,
        title: "بازنشانی رمز عبور",
        path: '/reset-password',
        component: ResetPassword,
        isProtected: false
    },
    {
        id: 5,
        title: "تایید ایمیل",
        path: '/verify-email',
        component: VerifyEmail,
        isProtected: false
    },
    {
        id: 6,
        title: "تایید ایمیل",
        path: '/sample',
        component: Sample,
        isProtected: false
    },
    {
        id: 7,
        title: "چاپ فاکتور",
        path: '/print',
        component: Print,
        isProtected: false
    },
    {
        id: 8,
        title: "چاپ فاکتور",
        path: '/test',
        component: Test,
        isProtected: false
    }
]

export const panelRoutes = [
    {
        id: 0,
        title: "داشبورد",
        path: "/dashboard",
        component: Dashboard,
        permission: ""
    },
    {
        id: 1,
        title: "کاربران | لیست",
        path: "/user/list",
        component: UsersList,
        permission: "UserUserList"
    },
    {
        id: 2,
        title: "کاربران | جدید",
        path: "/user/new",
        component: UserNew,
        permission: "UserAddNewUser"
    },
    {
        id: 3,
        title: "کاربران | ویرایش",
        path: "/user/edit/:id",
        component: UserEdit,
        permission: "UserUserItem"
    },
    {
        id: 4,
        title: "کاربران | ویرایش نقش",
        path: "/user/user-role/:id",
        component: UserRole,
        permission: "UserUserItem"
    },
    {
        id: 5,
        title: "نقش ها | لیست",
        path: "/config/role/list",
        component: RoleList,
        permission: "RoleRoleList"
    },
    {
        id: 6,
        title: "نقش ها | جدید",
        path: "/config/role/new",
        component: RoleNew,
        permission: "RoleAddRole"
    },
    {
        id: 7,
        title: "نقش ها | ویرایش",
        path: "/config/role/edit/:id",
        component: RoleEdit,
        permission: "RoleGetRoleItem"
    },
    {
        id: 8,
        title: "سطح دسترسی نقش ها | ویرایش",
        path: "/config/role/update-permission/:id",
        component: UpdateRolePermission,
        permission: "RoleGetRoleItem"
    },
    {
        id: 9,
        title: "سطح دسترسی ها | لیست",
        path: "/config/permission/list",
        component: PermissionList,
        permission: "PermissionPermissionList"
    },
    {
        id: 10,
        title: "سطح دسترسی ها | جدید",
        path: "/config/permission/new",
        component: PermissionNew,
        permission: "PermissionAddPermission"
    },
    {
        id: 11,
        title: "سطح دسترسی ها | ویرایش",
        path: "/config/permission/edit/:id",
        component: PermissionEdit,
        permission: "PermissionGetPermissionItem"
    },
    {
        id: 12,
        title: "دسته بندی سطح دسترسی ها | لیست",
        path: "/config/permission-category/list",
        component: PermissionCategoryList,
        permission: "PermissionCategoryPermissionCategoryList"
    },
    {
        id: 13,
        title: "دسته بندی سطح دسترسی ها | جدید",
        path: "/config/permission-category/new",
        component: PermissionCategoryNew,
        permission: "PermissionCategoryAddPermissionCategory"
    },
    {
        id: 14,
        title: "دسته بندی سطح دسترسی ها | ویرایش",
        path: "/config/permission-category/edit/:id",
        component: PermissionCategoryEdit,
        permission: "PermissionCategoryPermissionCategoryItem"
    },


    {
        id: 27,
        title: "کاربران | آپلود فایل اکسل",
        path: "/user/upload-excel",
        component: UploadUserExcelFIle,
        permission: "UserUploadExcelFile"
    },


    {
        id: 59,
        title: "ویرایش رمز عبور | ثبت",
        path: "/change-password",
        component: ChangeForcePassword,
        permission: "UserChangeUserPasswordByUser"
    },
    {
        id: 29,
        title: "شهرها | ویرایش",
        path: "/city/edit/:id",
        component: CityEdit,
        permission: "CityEditCity"
    },
    {
        id: 30,
        title: "شهرها | لیست",
        path: "/city/list",
        component: CityList,
        permission: "CityCityList"
    },
    {
        id: 31,
        title: "شهرها | ثبت",
        path: "/city/new",
        component: CityNew,
        permission: "CityAddCity"
    },
    {
        id: 30,
        title: "استان | ویرایش",
        path: "/state/edit/:id",
        component: StateEdit,
        permission: "StateEditState"
    },
    {
        id: 31,
        title: "استان | لیست",
        path: "/state/list",
        component: StateList,
        permission: "StateStateList"
    },
    {
        id: 32,
        title: "استان | ثبت",
        path: "/state/new",
        component: StateNew,
        permission: "StateAddState"
    },
    {
        id: 33,
        title: "دسته بندی محتوا | ویرایش",
        path: "/content-category/edit/:id",
        component: ContentCategoryEdit,
        permission: "ContentCategoryEditContentCategory"
    },
    {
        id: 34,
        title: "دسته بندی محتوا | لیست",
        path: "/content-category/list",
        component: ContentCategoryList,
        permission: "ContentCategoryContentCategoryList"
    },
    {
        id: 35,
        title: "دسته بندی محتوا | ثبت",
        path: "/content-category/new",
        component: ContentCategoryNew,
        permission: "ContentCategoryAddContentCategory"
    },{
        id: 36,
        title: "دسته بندی محصولات | ویرایش",
        path: "/product-category/edit/:id",
        component: ProductCategoryEdit,
        permission: "ProductCategoryEditProductCategory"
    },
    {
        id: 37,
        title: "دسته بندی محصولات | لیست",
        path: "/product-category/list",
        component: ProductCategoryList,
        permission: "ProductCategoryProductCategoryList"
    },
    {
        id: 38,
        title: "دسته بندی محصولات | ثبت",
        path: "/product-category/new",
        component: ProductCategoryNew,
        permission: "ProductCategoryAddProductCategory"
    },
    {
        id: 39,
        title: " محتوا | ویرایش",
        path: "/content/edit/:id",
        component: ContentEdit,
        permission: "ContentEditContent"
    },
    {
        id: 40,
        title: "محتوا | لیست",
        path: "/content/list",
        component: ContentList,
        permission: "ContentContentList"
    },
    {
        id: 41,
        title: "محتوا | ثبت",
        path: "/content/new",
        component: ContentNew,
        permission: "ContentAddContent"
    },
    {
        id: 42,
        title: " محتوا | ویرایش",
        path: "/branch/edit/:id",
        component: BranchEdit,
        permission: "BranchEditBranch"
    },
    {
        id: 43,
        title: "محتوا | لیست",
        path: "/branch/list",
        component: BranchList,
        permission: "BranchBranchList"
    },
    {
        id: 44,
        title: "محتوا | ثبت",
        path: "/branch/new",
        component: BranchNew,
        permission: "BranchAddBranch"
    },
    {
        id: 45,
        title: " محصولات | ویرایش",
        path: "/product/edit/:id",
        component: ProductEdit,
        permission: "ProductEditProduct"
    },
    {
        id: 46,
        title: "محصولات | لیست",
        path: "/product/list",
        component: ProductList,
        permission: "ProductProductList"
    },
    {
        id: 47,
        title: "محصولات | ثبت",
        path: "/product/new",
        component: ProductNew,
        permission: "ProductAddProduct"
    },
    {
        id: 48,
        title: " اسلایدر | ویرایش",
        path: "/slider/edit/:id",
        component: SliderEdit,
        permission: "SliderEditSlider"
    },
    {
        id: 49,
        title: "اسلایدر | لیست",
        path: "/slider/list",
        component: SliderList,
        permission: "SliderSliderList"
    },
    {
        id: 50,
        title: "اسلایدر | ثبت",
        path: "/slider/new",
        component: SliderNew,
        permission: "SliderAddSlider"
    },
    {
        id: 51,
        title: "دسته بندی سوالات متداول | ویرایش",
        path: "/frequent-question-category/edit/:id",
        component: FrequentQuestionCategoryEdit,
        permission: "FrequentQuestionCategoryEditFrequentQuestionCategory"
    },
    {
        id: 52,
        title: "دسته بندی سوالات متداول | لیست",
        path: "/frequent-question-category/list",
        component: FrequentQuestionCategoryList,
        permission: "FrequentQuestionCategoryFrequentQuestionCategoryList"
    },
    {
        id: 53,
        title: "دسته بندی سوالات متداول | ثبت",
        path: "/frequent-question-category/new",
        component: FrequentQuestionCategoryNew,
        permission: "FrequentQuestionCategoryAddFrequentQuestionCategory"
    },
    {
        id: 54,
        title: " سوالات متداول | ویرایش",
        path: "/frequent-question/edit/:id",
        component: FrequentQuestionEdit,
        permission: "FrequentQuestionEditFrequentQuestion"
    },
    {
        id: 55,
        title: " سوالات متداول | لیست",
        path: "/frequent-question/list",
        component: FrequentQuestionList,
        permission: "FrequentQuestionFrequentQuestionList"
    },
    {
        id: 56,
        title: " سوالات متداول | ثبت",
        path: "/frequent-question/new",
        component: FrequentQuestionNew,
        permission: "FrequentQuestionAddFrequentQuestion"
    },
    {
        id: 57,
        title: " سبد خری | ویرایش",
        path: "/user-basket/edit/:id",
        component: UserBasketEdit,
        permission: "BasketBasketDetail"
    },
    {
        id: 58,
        title: " سبد خرید | لیست",
        path: "/user-basket/list",
        component: UserBasketList,
        permission: "BasketBasketList"
    },
    {
        id: 59,
        title: " ارتباط با ما | ویرایش",
        path: "/contact-us/edit/:id",
        component: ContactUsEdit,
        permission: "ContactUsContactUsItem"
    },
    {
        id: 60,
        title: " ارتباط با ما | لیست",
        path: "/contact-us/list",
        component: ContactusList,
        permission: "ContactUsContactUsList"
    },
    {
        id: 61,
        title: "   دریافت اطلاعات نمایندگی | لیست",
        path: "/request-branch/list",
        component: RequestBranchList,
        permission: "BranchRequestUserGetBranchRequestUserList"
    },
    {
        id: 62,
        title: " محصولات کلی فروشی | ویرایش",
        path: "/branch-product/edit/:id",
        component: BranchProductEdit,
        permission: "BranchProductEditBranchProduct"
    },
    {
        id: 63,
        title: "محصولات کلی فروشی | لیست",
        path: "/branch-product/list",
        component: BranchProductList,
        permission: "BranchProductBranchProductList"
    },
    {
        id: 64,
        title: "محصولات کلی فروشی | ثبت",
        path: "/branch-product/new",
        component: BranchProductNew,
        permission: "BranchProductAddBranchProduct"
    },{
        id: 65,
        title: " سبد خرید | لیست",
        path: "/kashmar-user-basket/list",
        component: KashmarUserBasketList,
        permission: "BasketKashmarBasketList"
    },{
        id: 66,
        title: " سبد خرید | لیست",
        path: "/confirm-user-basket/list",
        component: ConfirmUserBasketList,
        permission: "BasketConfirmBasketList"
    },
    {
        id: 67,
        title: " درخواست نمایندگان | لیست",
        path: "/branch-basket/list",
        component: BranchBasketList,
        permission: "BranchBasketBranchBasketList"
    }, {
        id: 68,
        title: " درخواست نمایندگان | ویرایش",
        path: "/branch-basket/edit/:id",
        component: BranchBasketEdit,
        permission: "BranchBasketBranchBasketItem"
    },{
        id: 69,
        title: "درخواست استخدامی | لیست",
        path: "/employment/list",
        component: EmploymentList,
        permission: "ContactUsEmploymentList"
    },{
        id: 69,
        title: "درخواست افتتاح نمایندگی",
        path: "/branch-shop/list",
        component: BranchShop,
        permission: "BranchBranchRequestList"
    },
]
